import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field_show_downloads_page', () => {
  void import('./internal/map').then(({ default: Component }) => Component());
});
